var _ellipse, _path, _rect, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckedSpeechBubble(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 405,
    height: 344,
    viewBox: "0 0 405 344",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 202.5,
    cy: 145,
    rx: 202.5,
    ry: 145,
    fill: "#2E64AE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.5059 330.932L118.813 276.456L80.0025 255.075L63.5059 330.932Z",
    fill: "#2E64AE"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 98.0121,
    height: 29.0128,
    transform: "matrix(0.718753 0.695265 -0.696176 0.717871 114.479 134.322)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 29.0128,
    height: 188.398,
    transform: "matrix(0.726503 0.687163 -0.688083 0.725632 273.859 66.0039)",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedSpeechBubble);
export default __webpack_public_path__ + "static/media/checked-speech-bubble.2568552d41232de4300aed84f729c7d8.svg";
export { ForwardRef as ReactComponent };